export default {
  'accessLog.title': 'Gestionar Registros de Acceso',
  'accessLog.operationType.login': 'Inicio de sesión',
  'accessLog.operationType.logout': 'Cierre de sesión',
  'accessLog.operationType.refreshCredentials': 'Actualizar credenciales',
  'accessLog.form.operationType': 'Tipo de Operación',
  'accessLog.accessType.mixed': 'Mixto',
  'accessLog.accessType.userAndPassword': 'Usuario y contraseña',
  'accessLog.accessType.office365': 'Office365',
  'accessLog.accessType.google': 'Google',
  'accessLog.accessType.automy': 'AUTOMY',
  'accessLog.text.accessType': 'Tipo de acceso',
  'accessLog.text.isSuccessfulOperation': '¿Operación Satisfactoria?',
  'accessLog.text.ip': 'Ip',
  'accessLog.text.appClient': 'Aplicación',
  'accessLog.text.observations': 'Observaciones',
  'accessLog.text.country': 'País',
  'accessLog.text.city': 'Ciudad',
  'accessLog.text.state': 'Estado',
  'accessLog.text.userAgent': 'Agente',
};
